import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { AssignedTasksBanner } from "@/components/common/AssignedTasksNotifications";
import { ClientAssignmentBanner } from "@/components/common/ClientAssignmentBanner";

export function AppLayout() {
  const { pathname } = useLocation();
  const fullBleed = /^\/landing\/[^/]+\/editor\/?$/.test(pathname);
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <ClientAssignmentBanner />
        <AssignedTasksBanner />
        {fullBleed ? (
          <main className="min-w-0 flex-1 overflow-hidden" data-testid="app-main-fullbleed">
            <Suspense fallback={<div className="py-20 text-center text-sm text-muted-foreground" data-testid="page-loading">Caricamento…</div>}><Outlet /></Suspense>
          </main>
        ) : (
          <main className="flex-1 overflow-x-hidden px-4 py-6 sm:px-8 sm:py-8">
            <div className="w-full" data-testid="app-main-content">
              <Suspense fallback={<div className="py-20 text-center text-sm text-muted-foreground" data-testid="page-loading">Caricamento…</div>}><Outlet /></Suspense>
            </div>
          </main>
        )}
      </div>
    </div>
  );
}
